import script from "./customerCase.vue?vue&type=script&setup=true&lang=js"
export * from "./customerCase.vue?vue&type=script&setup=true&lang=js"

import "./customerCase.vue?vue&type=style&index=0&id=032eca06&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032eca06"]])

export default __exports__